import React from "react";
import "./about.scss";
import WebGLReveal from "../../../components/webgl-reveal/WebGLReveal";

const UserIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
        <circle cx="12" cy="7" r="4"></circle>
    </svg>
);

const BriefcaseIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect>
        <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
    </svg>
);

const AwardIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <circle cx="12" cy="8" r="7"></circle>
        <polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"></polyline>
    </svg>
);

const HomeAbout = () => {
    return (
        <div className="section bg-dark overflow-hidden" id="about">
            <div className="about-section section-padding mt-n3 mb-n1">
                <div className="container">
                    <div className="about-grid">
                        {/* Left Side: Visuals */}
                        <div className="about-visual">
                            <div className="image-wrapper">
                                <WebGLReveal
                                    primaryImg={`${process.env.PUBLIC_URL}/images/profile.png`}
                                    secondaryImg={`${process.env.PUBLIC_URL}/images/profile2.png`}
                                />

                                {/* Floating Stats Cards */}
                                <div className="stat-card stat-experience">
                                    <div className="stat-icon">
                                        <UserIcon />
                                    </div>
                                    <div className="stat-info">
                                        <span className="stat-value">
                                            5+ Years
                                        </span>
                                        <span className="stat-label">
                                            Experience
                                        </span>
                                    </div>
                                </div>

                                <div className="stat-card stat-projects">
                                    <div className="stat-icon">
                                        <BriefcaseIcon />
                                    </div>
                                    <div className="stat-info">
                                        <span className="stat-value">100+</span>
                                        <span className="stat-label">
                                            Projects Done
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Right Side: Content */}
                        <div className="about-content-modern">
                            <div className="section-badge">
                                <AwardIcon />
                                <span>About Me</span>
                            </div>

                            <h2 className="modern-title">
                                Transforming Ideas into <br />
                                <span className="highlight">
                                    Digital Reality
                                </span>
                            </h2>

                            <div className="description">
                                <p>
                                    Hello! I&apos;m{" "}
                                    <strong>Muhammad Sajid</strong>, a
                                    passionate Frontend Developer and tech
                                    enthusiast based in Bangladesh. I specialize
                                    in building high-performance, visually
                                    stunning web applications that merge
                                    creativity with technical precision.
                                </p>
                                <p>
                                    My expertise spans across{" "}
                                    <strong>Modern Web Development</strong>,{" "}
                                    <strong>Cyber Security</strong>, and{" "}
                                    <strong>Digital Strategy</strong>. I
                                    don&apos;t just write code; I craft seamless
                                    digital experiences that engage users and
                                    drive results.
                                </p>
                            </div>

                            <div className="cta-buttons">
                                <a
                                    href="#contact"
                                    className="btn-modern primary"
                                >
                                    Contact Me
                                </a>
                                <a href="/cv" className="btn-modern outline">
                                    Download CV
                                </a>
                            </div>

                            {/* Signature Block */}
                            <div className="signature-block">
                                <picture>
                                    <source
                                        srcSet={`${process.env.PUBLIC_URL}/images/signechar.webp`}
                                        type="image/webp"
                                    />
                                    <img
                                        className="signature-img"
                                        src={`${process.env.PUBLIC_URL}/images/signechar.jpg`}
                                        alt="Signature"
                                        loading="lazy"
                                        decoding="async"
                                    />
                                </picture>
                                <span className="name">Muhammad Sajid</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Liquid Wave Filter Definition */}
            <svg style={{ position: "absolute", width: 0, height: 0 }}>
                <filter id="liquid-reveal-filter">
                    <feTurbulence
                        type="fractalNoise"
                        baseFrequency="0.01 0.01"
                        numOctaves="2"
                        result="noise"
                    >
                        <animate
                            attributeName="baseFrequency"
                            values="0.01 0.01; 0.015 0.015; 0.01 0.01"
                            dur="5s"
                            repeatCount="indefinite"
                        />
                    </feTurbulence>
                    <feDisplacementMap
                        in="SourceGraphic"
                        in2="noise"
                        scale="30"
                        xChannelSelector="R"
                        yChannelSelector="G"
                    />
                </filter>
            </svg>
        </div>
    );
};

export default HomeAbout;
